import { Injectable, signal } from '@angular/core';

export type AuthModalType = 'login' | 'registro' | 'verificacion' | 'medio-pago' | 'tarjeta' | 'yape' | 'ticket-transfer' | null;

export enum AuthModalEnum {
  LOGIN = 'login',
  REGISTRO = 'registro',
  VERIFICACION = 'verificacion',
  MEDIO_PAGO = 'medio-pago',
  TARJETA = 'tarjeta',
  YAPE = 'yape',
  TICKET_TRANSFER = 'ticket-transfer',
}

@Injectable({ providedIn: 'root' })
export class AuthModalService {
  readonly activeModal = signal<AuthModalType>(null);

  open(modal: AuthModalType): void {
    this.activeModal.set(modal);
  }

  close(): void {
    this.activeModal.set(null);
  }

  switchTo(modal: AuthModalType): void {
    this.activeModal.set(modal);
  }
}
